import Alpine from "alpinejs";
import {$http} from "../../utils";

Alpine.data('login', () => ({
    email: '',
    password: '',
    errors: null,

    removeError(field) {
        if (!this.errors) {
            return false;
        }
        delete this.errors[field];
    },

    getError(field) {
        if (!this.errors) {
            return '';
        }
        return this.errors[field] ? this.errors[field][0] : '';
    },

    checkError(field) {
        if (!this.errors) {
            return false;
        }
        return this.errors[field] ? true : false;
    },

    submitForm(form) {
        const formData = new FormData();
        Array.from(form.elements).forEach(element => {
            if (element.name) {
                formData.append(element.name, element.value);
            }
        });

        $http.post(form.action, formData, {
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(response => {
                console.log(response.data);
                window.location.reload();
            })
            .catch(error => {
                if (error.response && error.response.status === 422) {
                    this.errors = error.response.data.errors
                }
                if (error.response && error.response.status === 401) {
                    this.errors = error.response.data.errors
                }
            });
    },
}))